import * as types from "../../_constants/types";

export default (state = { loading: false }, action) => {
    switch (action.type) {
        case types.TICKET_FETCHING:
            return { loading: true };

        case types.TICKET_FETCHING_COMPLETED:
            return { loading: false, err: action.err };

        case types.TICKET_FETCHING_CANCELLED:
            if (!state.loading) {
                return { loading: false, err: action.err };
            }
            return state;

        case types.TICKET_FETCHING_FAILED:
            return { loading: false, err: action.err };

        case types.TICKET_RESET:
            return { loading: state.loading };

        default:
            return state;
    }
};
